import { render, staticRenderFns } from "./SecureSBClientsFieldsSettings.vue?vue&type=template&id=37256b21"
import script from "./SecureSBClientsFieldsSettings.vue?vue&type=script&lang=js"
export * from "./SecureSBClientsFieldsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports